<template>
  <slot :open-menu="openMenu" />
</template>

<script setup lang="ts">
import { inject, watch, nextTick } from 'vue'
import { type MenuState } from '../types'

const emit = defineEmits<{
  focus: []
}>()

defineOptions({ inheritAttrs: false })

const menuState = inject<MenuState>('menuState')

const openMenu = () => {
  menuState?.openMenu()
}

watch(
  () => menuState?.shouldFocusTrigger.value,
  async (shouldFocusTrigger) => {
    if (shouldFocusTrigger) {
      await nextTick()
      emit('focus')
      menuState?.resetTriggerFocus()
    }
  },
)
</script>
